// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2aa9e916","455":"0581aeea","977":"dcb0dec3"}[chunkId] + ".chunk.js";
};